import {
    GET_COMPANY_DASHBOARD_STATS,
    GET_COMPANY_DASHBOARD_STATS_SUCCESS,
    GET_COMPANY_DASHBOARD_STATS_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    stats: null,
    error: {},
    loading: false
}

const DashboardCompany = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_COMPANY_DASHBOARD_STATS:
            return {
                ...state,
                loading: true,
            }
        case GET_COMPANY_DASHBOARD_STATS_SUCCESS:
            return {
                ...state,
                stats: action.payload,
                loading: false,
            }
        case GET_COMPANY_DASHBOARD_STATS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
            }
        default:
            return state
    }
}

export default DashboardCompany
